import { render, staticRenderFns } from "./SuperAdminStats.vue?vue&type=template&id=8a921c7a&scoped=true"
import script from "./SuperAdminStats.vue?vue&type=script&lang=js"
export * from "./SuperAdminStats.vue?vue&type=script&lang=js"
import style0 from "./SuperAdminStats.vue?vue&type=style&index=0&id=8a921c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a921c7a",
  null
  
)

export default component.exports